import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault'
import './styles.scss'

const bc = 'user-protrack-out-of-office'

class UserOutOfOfficeBlock extends Component {
  state = {
    isShow: true,
  }

  handleCloseBlock = () => this.setState({ isShow: false })

  render() {
    const { t, show, goToOutOfOffice } = this.props
    const { isShow } = this.state
    return (
      show &&
      isShow && (
        <div className={bc}>
          <span className={`${bc}__close`} onClick={this.handleCloseBlock}>
            x
          </span>
          <span>{t('Out of office is currently active')}</span>
          <Button className={`${bc}__button`} primary sm onClick={goToOutOfOffice}>
            {t('Change settings')}
          </Button>
        </div>
      )
    )
  }
}

UserOutOfOfficeBlock.propTypes = {
  show: PropTypes.bool.isRequired,
  goToOutOfOffice: PropTypes.func.isRequired,
}

export default withTranslation('user')(UserOutOfOfficeBlock)
